import React from "react";
import styled from "styled-components";
import { useEffect } from "react";

const AccessibilityCss = styled.div`

.accessiblity-content{
   padding-top:50px;
   padding-bottom:50px;

        h2{
            text-align: center;
        }
        p{
            text-align: left;
            padding-top: 20px;
            font-size: 19px;
            font-family: sans-serif;
            padding-right: 69px;

        }
        
        }
}

`;

const Accessibility=()=>{
    useEffect(() => {
            window.scrollTo(0, 0)
          }, []);
    return(
        <AccessibilityCss>
        <div className="container">
            <div className="accessiblity-content">
                <h2>SHAREKAIRE COMMITMENT <br></br>TO ACCESSIBILITY </h2>

                <p>Kaire is dedicated to celebrating and serving all people, ensuring our website reflects inclusivity and diversity for everyone. 
                    We are committed to making our website&#39;s content accessible and user-friendly for all. If you encounter any difficulties in viewing or 
                    navigating our site, or if you believe any content, feature, or functionality is not fully accessible to individuals with disabilities, 
                    please contact our Customer Service team. You can reach us by calling 1-877-603-1710, or by emailing <a href="mailto:support@kaire.com">support@kaire.com</a> with 
                    the subject line &quot;Disabled Access.&quot; 
                    Please include a description of the specific feature you find inaccessible or suggest any improvements.</p>

                    <p>We take your feedback seriously as we assess ways to better accommodate all our customers and improve our accessibility policies. 
                        While we do not control third-party vendors, 
                        we strongly encourage them to ensure their digital content is both accessible and user-friendly. </p>
            </div>
        </div>
        </AccessibilityCss>
    )
}
export default Accessibility;